import request from '@/utils/request'

// 查询型号规格分页
export function fetchList(query) {
    return request({
        url: 'fix/model/caliber/integral/page',
        method: 'get',
        params: query,
    })
}
// 查询型号详细
export function getObj(id) {
    return request({
        url: '/fix/model/detail?id=' + id,
        method: 'get',
    })
}
// 设置单独积分
export function addObj(data) {
    return request({
        url: '/fix/model/caliber/integral/add',
        method: 'post',
        data: data,
    })
}
// 统一一设置积分赋能
export function addTy(data) {
    return request({
        url: '/fix/model/caliber/integral/empower/unify',
        method: 'post',
        data: data,
    })
}
// 单独设置积分赋能
export function addOne(data) {
    return request({
        url: '/fix/model/caliber/integral/empower/one',
        method: 'post',
        data: data,
    })
}
// 修改型号
export function putObj(data) {
    return request({
        url: '/fix/model/edit',
        method: 'post',
        data: data,
    })
}
// 删除型号
export function delObj(data) {
    return request({
        url: '/fix/model/delete',
        method: 'post',
        data: data,
    })
}
// 禁用型号
export function statusObj(data) {
    return request({
        url: '/fix/model/status',
        method: 'get',
        params: data,
    })
}